import React, { Component } from 'react';
import SearchBox from '../../shared/SearchBox';
import { actions } from '../../helpers/messages';
import { DataTable } from '../DataTable/DataTable';
import { MappingRoles } from '../../helpers/constants';
import MappedUserModal from './MappedUserModal';

class MappedUserList extends Component {
    /**
     * @description Function to handle user's role display
     * @param role Role of the user instance
     * @memberof Header
     */
    getRoleName(role) {
        const userRole = MappingRoles.find(x => x.userRole === role.toLowerCase());
        return userRole && userRole.specialLabel ? userRole.label : role;
    }

    /**
     * @description Function to handle user's name display
     * @param name Name of the user instance
     * @memberof Header
     */
    getNameShort = (name) => {
        return name?.length > 20 ? `${name.substring(0, 20)}...` : name;
    }

    render() {
        const { loading, toggleLoader, fromDashboard, searchString, searchSubmit, refreshUserList, handleSearchSubmit, handleReset, mappedUserUpdated, userStatusUpdated, newUserName } = this.props;
        /* istanbul ignore next  */
        const columns = [
            {
                Header: 'Name',
                accessor: 'name',
                Cell: ({ row }) => (<span>{row.original.name ? this.getNameShort(row.original.name) : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: 'Email',
                accessor: 'email',
                Cell: ({ row }) => (<span>{row.original.email ? row.original.email : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: 'Role',
                accessor: 'dapRole',
                Cell: ({ row }) => (<span>{row.original.dapRole ? this.getRoleName(row.original.dapRole) : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: ' ',
                snUserAction: true
            }

        ];
        return (
            <div>
                {loading ? <div className="loading-overlay"><span>{actions.load}</span></div> : null}
                <div className="bgGray">
                    <div className="surgeon-list table-wrap px-3" data-testid="SNUserList">
                        <div className="row">
                            <div className="col-md-6">
                                <SearchBox handleSearchSubmit={handleSearchSubmit} handleReset={handleReset} />
                            </div>
                            <div className="col-md-6 text-end">
                                <MappedUserModal fromDashboard={fromDashboard} mappedUserUpdated={mappedUserUpdated} />
                            </div>
                        </div>
                        <div className="user-list-container">
                            <DataTable
                                listType="mapped-user-list"
                                showPagination={true}
                                columns={columns}
                                newUserName={newUserName ? newUserName : ''}
                                searchString={searchString && searchSubmit ? searchString : ''}
                                refreshDataList={searchSubmit || refreshUserList}
                                userStatusUpdated={userStatusUpdated}
                                toggleLoader={toggleLoader}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MappedUserList;
